import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetTableRow } from '../data-maintenance.model';

@Component({
  selector: 'app-override-indicator-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (rowData?.isUserOverride) {
      <span class="override-dot" title="User modified"></span>
    }
  `,
  styles: [
    `
      .override-dot {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #ff80ff;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverrideIndicatorRendererComponent {
  @Input() rowData: AssetTableRow | undefined;
}
